import { Navigate, Outlet, useLocation } from "react-router-dom";
import { donusYoluKaydet, isAuth } from "../helpers/auth";
import { lazy, useEffect, useState } from "react";
import { bildirimRolunuUygula, rolGecisiGerekliMi } from "../helpers/bildirimRol";
import { sayfaAcilisiniIsaretle } from "../helpers/yetkiYonlendirme";

// SideBar (+ HizliBagis/display/exceljs zinciri) çerçeveli sayfalarda gerekir; Ortak (çerçevesiz) açılışında inmesin.
const SideBarPage = lazy(() => import("../component/Login/SideBar"));

function PrivateRoute(props) {
  const [selectedWindow, setSelectedWindow] = useState(0);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  // Bildirimden rol geçişi bekliyor mu? RENDER SIRASINDA belirleniyor, effect'te DEĞİL:
  // React'te çocuk effect'leri ebeveynden önce çalıştığı için, effect'e bırakırsak sayfa
  // çoktan mount olur ve verisini ESKİ rolle ister — kullanıcı gereksiz "yetki yok"
  // uyarısı alır, hatta güvenli sayfaya atılır (canlı gözlem 2026-08-04).
  // Bayrak true iken <Outlet /> HİÇ render edilmez, yani hiçbir sayfa isteği çıkmaz.
  const [rolBekliyor, setRolBekliyor] = useState(() =>
    isAuth() ? rolGecisiGerekliMi() : false
  );

  function handleWindowResize() {
    const width = window.innerWidth;
    if (width <= 750) {
      setSelectedWindow(1);
    } else if (width > 750 && width <= 1000) {
      setSelectedWindow(2); // Orta ekran boyutu için yeni bir durum
    } else {
      setSelectedWindow(0);
    }
  }

  useEffect(() => {
    window.addEventListener("resize", handleWindowResize);
    handleWindowResize(); // İlk yükleme için kontrol et

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  // Sayfa açılış anını işaretle: yetkisiz-yönlendirme, SAYFA AÇILIŞINDAKİ 403 ile
  // butona basınca gelen 403'ü ancak bu zamanla ayırabiliyor (bkz.
  // helpers/yetkiYonlendirme.js F1). Buton 403'ünde kullanıcı sayfadan atılmamalı.
  useEffect(() => {
    sayfaAcilisiniIsaretle();
  }, [location.pathname]);

  // Bildirimden gelen otomatik rol geçişi. Burada duruyor çünkü OTURUM AÇIK olan tek
  // ortak nokta burası; oturum kapalıysa aşağıdaki dal zaten girişe yönlendirir ve
  // dönüş yolu (sorgu parametresi dahil) kaydedilir, akış giriş sonrası çalışır.
  useEffect(() => {
    if (!rolBekliyor) return;
    let iptal = false;
    // Başarılı geçişte adres zaten değişir (assign/reload) ve bu bileşen yok olur;
    // bayrağın sıfırlanması "geçiş yapılmadı/yapılamadı" hâli içindir — o durumda
    // sayfa normal şekilde render edilmeli, kullanıcı boş ekranda kalmamalı.
    bildirimRolunuUygula().finally(() => {
      if (!iptal) setRolBekliyor(false);
    });
    return () => {
      iptal = true;
    };
  }, [rolBekliyor]);

  if (!isAuth()) {
    // Cookie'nin 1 saatlik ömrü dolduğunda buraya 403 GELMEDEN düşülür ve
    // signout() hiç çalışmaz — dönüş yolunu bu yüzden burada kaydediyoruz.
    // useEffect'e alınamaz: <Navigate> yönlendirmeyi kendi effect'inde yapar ve
    // çocuk effect'leri ebeveynden önce çalıştığı için kayıt geç kalır.
    // donusYoluKaydet zaten açık oturum yoksa hiçbir şey yazmaz.
    donusYoluKaydet(location.pathname + location.search);
    return <Navigate to="/" />;
  }

  // ORTAK YUKLEME SAYFASI CERCEVESIZ (kullanici karari 01.10.2026).
  // Navbar, sidebar, alt menu — hicbiri cizilmez. Sahadaki personel tek bir
  // ise odaklansin diye. Ayrica bir HATAYI da gideriyor: cerceve ciziliyorken
  // `/ortak`ta projeId olmadigi icin `GET /api/ui/config/undefined` 404
  // donuyordu (loglarda gorildu).
  const cercevesiz = /^\/(projeId\/)?ortak(\/|$)/.test(location.pathname);
  if (cercevesiz) {
    return rolBekliyor ? (
      <div className="px-4 py-12 text-center opacity-75">
        Yetkiniz hazırlanıyor, lütfen bekleyin...
      </div>
    ) : (
      <Outlet />
    );
  }

  return (
    <div className="w-full relative min-h-screen">
      <SideBarPage
        selectedWindow={selectedWindow}
        isOpen={sidebarOpen}
        setIsOpen={setSidebarOpen}
      >
        {/* Rol geçişi biterken sayfa render EDİLMEZ: aksi halde sayfa verisini eski
            rolle ister ve boşuna 403 alır. */}
        {rolBekliyor ? (
          <div className="px-4 py-12 text-center opacity-75">
            Yetkiniz hazırlanıyor, lütfen bekleyin...
          </div>
        ) : (
          <Outlet />
        )}
      </SideBarPage>
    </div>
  );
}

export default PrivateRoute;
